import React, { useState } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import TabsCustom from "../../components/TabsCustom";
import { Tabs } from "antd";
import { useWindowSize } from "../../hook/useWindowSize";
import { TabContent } from "./components/TabContent";

export const TabPurchaseOption = {
  mall: "mall",
  app: "app",
  market: "market",
};

export const MyPurchase = () => {
  const { T, user } = useApp();
  const [tab, setTab] = useState(TabPurchaseOption.mall);
  const size = useWindowSize();

  return (
    <Container>
      <ContainerView background="transparent">
        <TitlePage>{T("My Purchase")}</TitlePage>
        <TabsCustom
          spaceItem={size.width > 1024 ? 32 : 30}
          className="v2 mt-[18px]  lg:mt-[40px] xls:[54px]"
          activeKey={tab}
          onChange={(e) => setTab(e)}
          destroyInactiveTabPane={true}
        >
          <Tabs.TabPane tab={T("Mall")} key={TabPurchaseOption.mall}>
            <TabContent tab={TabPurchaseOption.mall} />
          </Tabs.TabPane>

          <Tabs.TabPane tab={T("A2V app")} key={TabPurchaseOption.app}>
            <TabContent tab={TabPurchaseOption.app} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={T("C2C market")} key={TabPurchaseOption.market}>
            <TabContent tab={TabPurchaseOption.market} />
          </Tabs.TabPane>
        </TabsCustom>
      </ContainerView>
    </Container>
  );
};
